import script from "./MarkSheetReadingForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarkSheetReadingForm.vue?vue&type=script&setup=true&lang=ts"

export default script